import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';

import thunk from 'redux-thunk';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
    const middleware = [thunk, routerMiddleware(history), sagaMiddleware];

    const enhancers = [];
    if (__DEBUG__) {
        const devToolsExtension = window.devToolsExtension;
        if (typeof devToolsExtension === 'function') {
            enhancers.push(devToolsExtension());
        }
    }

    const store = createStore(
        createRootReducer(), // root reducer with router state
        preloadedState,
        compose(
            applyMiddleware(...middleware),
            ...enhancers
        )
    );
    store.asyncReducers = {};

    if (module.hot) {
        module.hot.accept('./reducers', () => {
            const reducers = require('./reducers').default;
            store.replaceReducer(reducers);
        });
    }

    sagaMiddleware.run(sagas);

    return store;
}
